import Vue from 'vue'

Vue.filter('formatPhone', function (value) {
    if (value) {
        return value.replace(/(\d{2})(\d)(\d{4})(\d{4})$/, '($1) $2 $3-$4');
    }
})



// WEBPACK FOOTER //
// ./resources/js/plugins/phone_filter.js